import { useOutletContext, useParams, NavLink } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';

import { ErrorBanner, TitleWMutedRow } from '../../../sitel/demon/ui/atoms';
import { FieldValidationErrorMsg, HelpText } from '../../../sitel/demon/ui/atoms/form';

import schema from "./formSchema";
import useFormSubmit from "./useFormSubmit";
import useShowHidePassword from "./useShowHidePassword";
import { InputTextSingleColumn } from "../../../sitel/demon/ui/form";
import SubmitButton from "../../../sitel/demon/ui/atoms/buttons/SubmitButton";

export default function Step2CredentialsPage() {
    const { register, handleSubmit, formState: { errors, isSubmitting, isSubmitSuccessful } } = useForm({ resolver: yupResolver(schema()) });
    const { originApp, medstarAssociationType } = useParams();
    const onSubmit = useFormSubmit(originApp, medstarAssociationType);
    const url = new URL(window.location.href);
    const [showHidePassword, setshowHidePassword] = useShowHidePassword();
    const { language } = useOutletContext();

    //error handling - abstract!
    const error = url.searchParams.get("error");
    let errorBannerText = "";
    if (error === "unknown") {
        errorBannerText = "An unknown server error has occurred. Please try again in few minutes.";
    } else if (error === "duplicate resource") {
        errorBannerText = (<>This user already exists. Would you like to <NavLink to="../../auth/resetpassword/step1/createrequest">reset your password?</NavLink></>);
    } else if (error === "badcode") {
        errorBannerText = (<>The code you entered has expired or was wrong! Please try again</>);
    }
    return (
        <>
            <ErrorBanner errorText={errorBannerText} />
            <TitleWMutedRow muted={language.mutedTitle}>{language.title}</TitleWMutedRow>
            <h4 className="mb-3">Create your account</h4>
            <form onSubmit={handleSubmit(onSubmit)}>
                <InputTextSingleColumn labelText="First name" id="firstName" register={register} errors={errors} placeholder="A-Z and spaces" showIsRequired />
                <InputTextSingleColumn labelText="Last name" id="lastName" register={register} errors={errors} placeholder="A-Z and spaces" showIsRequired />
                <InputTextSingleColumn labelText="Email address" id="email" register={register} errors={errors} placeholder="@gmail.com @yahoo.com etc" maxlength='50' showIsRequired />
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="sesame1">Password</label>
                        <div className="borderx position-relative">
                            <input type={showHidePassword.inputType} className="form-control border w-100" id="sesame1" placeholder="Password"  {...register("sesame1")} />
                            <span role="button" className="position-absolute top-50 end-0 translate-middle" onClick={setshowHidePassword}><i className={`fa-regular ${showHidePassword.check ? 'fa-eye' : 'fa-eye-slash'}`}></i></span>
                        </div>
                        <FieldValidationErrorMsg field="sesame1" errors={errors} />
                    </div>
                    <div className="form-group mt-2">
                        <input type={showHidePassword.inputType} className="form-control" id="sesame2" placeholder="Confirm"  {...register("sesame2")} />
                        <HelpText>Must contain eight characters, one uppercase, one lowercase, one number and one special case character</HelpText>
                        <FieldValidationErrorMsg field="sesame2" errors={errors} />
                    </div>
                </div>
                <div className="form-row align-items-center">
                    <div className="col-auto mt-4">
                        <SubmitButton isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful && !error} defaultLabel="Create the account" className="btn-medstar-primary"/>
                    </div>
                </div>
            </form>
        </>
    );
}
